// 비로그인 때 만든 로컬 대화 id. Firestore 문서가 없어 로그인 후 이 id 로 저장하면 매번 실패한다.
export const isAnonymousConversationId = (conversationId) => (
  typeof conversationId === 'string' && /^(temp_)?anonymous_/.test(conversationId)
);
